package com.catbit.opinionpoll.data.models

data class HomeModel(
    val greetings: String,
    val forms: List<SimplifiedFormModel>
)